import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, PLATFORM_ID } from '@angular/core';
import { Subject, Subscription, of, pipe } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { MyAccountService } from 'src/app/services/feature/MyAccount/my-account.service';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';

@Component({
  selector: 'app-my-account-left-sidenav',
  templateUrl: './my-account-left-sidenav.component.html',
  styleUrls: ['./my-account-left-sidenav.component.scss'],
  standalone: false
})
export class MyAccountLeftSidenavComponent {
  @Input()
  navState: string;
  @Input()
  childNavState: string;

  panelOpenState: boolean[] = [false];
  panelOpenStateMyCompany: boolean[] = [false];

  mobNavState: string;
  mobChildNavState: string;

  isMobile: boolean = false;
  sub = new Subscription();
  private unsubscribe$ = new Subject<void>();
  navNodes: any;
  hideActiveState: boolean = true;
  platformId = inject(PLATFORM_ID);
  constructor(
    public leftnav: MyAccountService,
    private langService: KBLanguageService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.hideActiveState = !window.location.href.includes('return-request');
    }
    this.leftnav.getLeftSideNavMyAccountApi();
    this.callApi();
  }

  ngAfterViewInit() {
    this.langService.getActive().pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe((lang: any) => {

      if (lang) {
        this.apiCaller();
      }
    });
  }

  apiCaller() {
    this.leftnav.getLeftSideNavMyAccountApiLangChange().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => { this.leftnav.myAccount$ = of(res); this.cdr.detectChanges(); });
  }

  callApi() {
    if (this.isMobile) {
      this.leftnav.navId.pipe(takeUntil(this.unsubscribe$)).subscribe((state) => {
        this.mobNavState = state;
      })
      this.leftnav.childNavId.pipe(takeUntil(this.unsubscribe$)).subscribe((state) => {
        this.mobChildNavState = state;
      });
    }
  }

  hideOnMobile() {
    if (this.isMobile) {
      this.leftnav.canClose.next(false);
    }
  }

  user: any
  displayChildNavOrNot(childNav: any) {
    this.sub.add(
      this.leftnav.myAccount$.pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
        this.user = res.user;
      })
    );
    const accessMap: Record<string, () => boolean> = {
      //Technical Tranining 
      MyTrainingParentNavNode: () => this.user.accessRequests.includes('TECHNICAL_TRAINING'),
      MyParticipantsNavNode: () => this.user.accessRequests.includes('TECHNICAL_TRAINING'),
      MyTrainingHistoryNavNode: () => this.user.accessRequests.includes('TECHNICAL_TRAINING'),
      MyBookedTraining: () => this.user.accessRequests.includes('TECHNICAL_TRAINING'),
      TrainingNavNodeEntry: () => this.user.accessRequests.includes('TECHNICAL_TRAINING'),
      MyReportFilesNavNode: () => this.user.customerDocDownloadAccess,
      MyOwnPartNavNode: () => this.user.updateMyPart,

      // Quotes
      MyQuotesNavNode: () => {
        const uidSegment = this.user.currentB2BUnitWS.uid.split('_')[2];
        return (uidSegment === '10' || uidSegment === '20') &&
          !this.user.currentB2BUnitWS.marketSegment &&
          this.user.currentB2BUnitWS.marketSegment !== 'Y4';
      },

      // Price Files
      MyPriceFilesNavNode: () => this.user.downloadPriceDoc,

      // Dealer ADB
      BreakApplicationFormSearchNAVNode: () => this.user.dealerADBAccess,
      BreakApplicationFormNAVNode: () => this.user.dealerADBAccess,

      ADBFormNavNode: () => this.user.dealerADBAccess,
      MyOrdersNavNode: () => this.user.onlineOrdering,
      'Quick Order': () => this.user.onlineOrdering,
      'Upload Order Template': () => this.user.onlineOrdering,

      //CoreRights
      SubmitCoreReturnNavNode: () => this.user.coreRights.includes('CORE_SUBMISSION'),
      CoreReportsNavNode: () => this.user.coreRights.includes('CORE_REPORTS'),
      CoreLookupNavNode: () => this.user.coreRights.length > 0,
      CoreReturnSearchComponentNavNode: () => this.user.coreRights.length > 0,

      //WarrentyRights
      SubmitWarrantyClaimNavNode: () => this.user.warrantyRights.includes('WARRANTY_CLAIM'),
      SearchWarrantyClaimNavNode: () => this.user.warrantyRights.includes('WARRANTY_SEARCH'),
    };
    const checkAccess = accessMap[childNav.nodeId] || accessMap[childNav.nodeName];
    return checkAccess ? checkAccess() : true;
  }
  hasVisibleChildren(nav: any): boolean {
    if (!nav.childNodes?.length) {
      return false;
    }

    return nav.childNodes.some((child: any) =>
      this.displayChildNavOrNot(child)
    );
  }
  hasVisibleCompanyChildren(nav: any): boolean {
    if (!nav?.childNodes?.length) {
      return false;
    }

    return nav.childNodes.some((child: any) =>
      this.displayChildNavOrNot(child)
    );
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (isPlatformBrowser(this.platformId)) {
      this.leftnav.currentLang = window.localStorage.getItem('spartacus⚿⚿language');
    }
  }
}
